import { render } from "./Configurator.vue?vue&type=template&id=fe0d98ca&scoped=true"
import script from "./Configurator.vue?vue&type=script&lang=js"
export * from "./Configurator.vue?vue&type=script&lang=js"

import "./Configurator.vue?vue&type=style&index=0&id=fe0d98ca&lang=css&scoped=true"

import exportComponent from "/Users/soup/Development/Vue/rethinkrobotics/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe0d98ca"]])

export default __exports__